<ng-container>
  <div class="tw-mb-3 tw-mt-6 tw-text-2xl tw-font-medium sm:tw-mb-1.5 sm:tw-text-lg">
    {{ "currentAccess" | i18n }}
  </div>
  <div
    *ngIf="!isPremiumUser"
    class="tw-w-[84px] tw-rounded-full tw-bg-dt-surface-elevated tw-py-3 tw-text-center tw-text-lg tw-font-medium tw-text-dt-text-action sm:tw-mb-6 sm:tw-w-[67px] sm:tw-py-2 sm:tw-text-base"
  >
    {{ "free" | i18n }}
  </div>

  <div
    *ngIf="isPremiumUser"
    class="tw-flex tw-h-fit tw-w-fit tw-items-center tw-justify-center tw-rounded-full tw-bg-dt-surface-elevated tw-px-4 tw-text-lg tw-font-medium tw-text-dt-text-action sm:tw-text-base"
  >
    <icon [name]="'diamond'" [size]="10" class="tw-mt-2"></icon>
    <span class="tw-whitespace-nowrap tw-text-dt-text-headings">{{ "earlyAccess" | i18n }}</span>
  </div>

  <section class="tw-my-8 sm:tw-my-4">
    <span class="tw-text-[18.2px] tw-font-medium sm:tw-text-base">{{ "free" | i18n }}</span>
    <p
      class="tw-mt-2 tw-rounded-lg tw-border tw-border-neutral-100 tw-px-6 tw-py-4 sm:tw-px-3 sm:tw-py-2"
    >
      {{ "freeAccessContent1" | i18n }} <br />{{ "freeAccessContent2" | i18n }}
    </p>
  </section>
  <section class="tw-my-8 sm:tw-my-4">
    <span class="tw-text-[18.2px] tw-font-medium sm:tw-text-base">{{ "earlyAccess" | i18n }}</span>
    <div
      class="tw-mt-2 tw-flex tw-flex-col tw-gap-2 tw-rounded-lg tw-border tw-border-neutral-100 tw-px-6 tw-py-4 sm:tw-px-3 sm:tw-py-2"
    >
      <div class="tw-flex tw-gap-1">
        <icon [name]="'diamond'" [size]="10"></icon>
        <span class="tw-mt-1 tw-font-medium">{{ "earlyAccess" | i18n }}</span>
      </div>
      <p class="tw-mt-0 tw-mb-2">
        {{ "earlyAccessContent1" | i18n }} <br />
        {{ "earlyAccessContent2" | i18n }}
      </p>
      <app-gloss-button
        *ngIf="!isPremiumUser"
        class="tw-flex tw-w-64 sm:tw-w-full"
        [options]="requestAccessButtonOptions"
      ></app-gloss-button>
    </div>
  </section>
</ng-container>
